import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private readonly clearHandlers = new Set<() => void>();

  register(clearHandler: () => void): () => void {
    this.clearHandlers.add(clearHandler);
    return () => this.clearHandlers.delete(clearHandler);
  }

  clearAll(): void {
    this.clearHandlers.forEach((clearHandler) => {
      clearHandler();
    });
  }
}
